import React from "react";
import { injectIntl } from "react-intl";

export const injectIntlHelperHOC = WrappedComponent =>
  injectIntl(props => {
    const { intl } = props;
    const helper = (id, values) =>
      intl.formatMessage(
        {
          id,
        },
        {
          ...values,
          strong: (msg) => `<strong>${msg}</strong>`,
          br: `<br/>`,
        }
      );
    return <WrappedComponent {...props} intlh={helper} />;
  });
